import { api } from "@/lib/api";
import { useAuthStore } from "@/stores/auth";
import type { User } from "@/types/user";

export type LoginCredentials = {
  email: string;
  password: string;
};

export type LoginResponse = {
  token: string;
  user: User;
};

export async function login(credentials: LoginCredentials): Promise<LoginResponse> {
  const res = await api.post<LoginResponse>("/api/auth/login", credentials);
  useAuthStore.getState().setAuth(res.data.token, res.data.user);
  return res.data;
}

export async function logout(): Promise<void> {
  try {
    await api.post("/api/auth/logout");
  } catch {
    // Silent — clear even if request fails
  } finally {
    useAuthStore.getState().clear();
  }
}

export async function fetchMe(): Promise<User> {
  const res = await api.get<{ data: User } | User>("/api/auth/me");
  // Laravel JsonResource wraps in 'data' by default
  const user = (res.data as { data?: User }).data ?? (res.data as User);
  useAuthStore.getState().setUser(user);
  return user;
}
